module.exports = __webpack_public_path__ + "static/img/Steve-Roach.8a16a75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steve-Roach.jpg
// module id = k19W
// module chunks = 0